import React from 'react';

function AlgemeneVoorwaarden() {
  return (
    <div style={{ textAlign: 'left', marginLeft: '10%', marginRight: '10%' }}>
      <h1>Algemene Voorwaarden</h1>
      <p>
        <strong>Artikel 1: Definities</strong><br />
        1.1. Taxi: Een motorvoertuig bestemd voor het verrichten van taxivervoer.<br />
        1.2. Vervoerder: Het taxibedrijf dat de taxidiensten aanbiedt.<br />
        1.3. Klant: De natuurlijke of rechtspersoon die gebruik maakt van de taxidiensten.<br />
        1.4. Overeenkomst: De overeenkomst tussen de vervoerder en de klant met betrekking tot het taxivervoer.
      </p>

      <p>
        <strong>Artikel 2: Toepasselijkheid</strong><br />
        2.1. Deze algemene voorwaarden zijn van toepassing op alle overeenkomsten en diensten van de vervoerder.<br />
        2.2. Afwijkingen van deze voorwaarden zijn slechts geldig indien deze schriftelijk zijn overeengekomen.
      </p>

      <p>
        <strong>Artikel 3: Totstandkoming Overeenkomst</strong><br />
        3.1. De overeenkomst komt tot stand op het moment dat de klant een taxirit bestelt en de vervoerder deze aanvaardt.<br />
        3.2. De vervoerder heeft het recht om een bestelling te weigeren zonder opgaaf van redenen.
      </p>

      <p>
        <strong>Artikel 4: Tarieven en Betaling</strong><br />
        4.1. De geldende tarieven zijn de tarieven zoals vermeld op de website of anderszins aan de klant kenbaar gemaakt.<br />
        4.2. Betaling dient te geschieden contant, per pin of via andere aangeboden betaalmethoden direct na afloop van de rit.<br />
        4.3. Bij niet tijdige betaling is de klant van rechtswege in verzuim en is een wettelijke rente verschuldigd.
      </p>

      <p>
        <strong>Artikel 5: Verplichtingen van de Klant</strong><br />
        5.1. De klant dient zich correct te gedragen en de aanwijzingen van de chauffeur op te volgen.<br />
        5.2. Het is de klant verboden om schade te veroorzaken aan de taxi of de chauffeur te hinderen.<br />
        5.3. Bij overtreding van deze verplichtingen is de klant aansprakelijk voor de geleden schade.
      </p>

      <p>
        <strong>Artikel 6: Aansprakelijkheid</strong><br />
        6.1. De vervoerder is niet aansprakelijk voor schade als gevolg van vertraging, tenzij er sprake is van opzet of grove schuld.<br />
        6.2. De aansprakelijkheid van de vervoerder is beperkt tot de directe schade en tot maximaal het bedrag van de ritprijs.
      </p>

      <p>
        <strong>Artikel 7: Klachten</strong><br />
              7.1. Klachten over de dienstverlening dienen zo spoedig mogelijk, doch uiterlijk binnen 14 dagen na de rit,  <a href="/klachtenregeling">via deze link</a> te worden ingediend.<br />
        7.2. De vervoerder zal de klacht onderzoeken en trachten een passende oplossing te bieden.
      </p>

      <p>
        <strong>Artikel 8: Toepasselijk Recht en Geschillen</strong><br />
        8.1. Op deze algemene voorwaarden is Nederlands recht van toepassing.<br />
        8.2. Geschillen zullen worden voorgelegd aan de bevoegde rechter in het arrondissement waar de vervoerder is gevestigd.
      </p>
    </div>
  );
}

export default AlgemeneVoorwaarden;